<div class="language-checkbox-container">
  <label class="text-label">
    <mat-checkbox
      (change)="$event ? masterToggle('main') : null"
      [checked]="selection['main'].hasValue() && isAllSelected('main')"
      [indeterminate]="selection['main'].hasValue() && !isAllSelected('main')"
    >
      <h4>main languages</h4>
    </mat-checkbox>
  </label>
  <div class="checkbox-container">
    @for (mainLanguage of languages['main']; track mainLanguage) {
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        [disabled]="mainLanguage?.lnCode === mandatoryLanguage"
        (change)="onSelectionChange($event, mainLanguage, 'main')"
        [checked]="selection['main'].isSelected(mainLanguage)"
      >
        {{ mainLanguage?.name }}
      </mat-checkbox>
    }
  </div>
</div>
<div class="language-checkbox-container">
  <label class="text-label">
    <mat-checkbox
      (change)="$event ? masterToggle('additional') : null"
      [checked]="selection['additional'].hasValue() && isAllSelected('additional')"
      [indeterminate]="selection['additional'].hasValue() && !isAllSelected('additional')"
    >
      <h4>additional languages</h4>
    </mat-checkbox>
  </label>
  <div class="checkbox-container">
    @for (additionalLanguage of languages['additional']; track additionalLanguage) {
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        (change)="onSelectionChange($event, additionalLanguage, 'additional')"
        [checked]="selection['additional'].isSelected(additionalLanguage)"
      >
        {{ additionalLanguage?.name }}
      </mat-checkbox>
    }
  </div>
</div>
